import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-file-preview-dialog',
  templateUrl: './file-preview-dialog.component.html',
  styleUrls: ['./file-preview-dialog.component.css']
})
export class FilePreviewDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { file: any, url: string }) {}

  ngOnInit(): void {
  }

  isImage(fileName: string): boolean {
    return /\.(png|jpe?g|gif)$/i.test(fileName);
  }
  
  isPdf(fileName: string): boolean {
    return fileName.toLowerCase().endsWith('.pdf');
  }
  
  isText(fileName: string): boolean {
    return /\.(txt|log)$/i.test(fileName);
  }
  

}
